import { motion } from "framer-motion";
import { Layers, Globe2, Headphones, Zap, Rocket, BarChart } from "lucide-react";

const valueProps = [
  {
    icon: Layers,
    title: "Single Provider Simplicity",
    description: "One relationship managing all connectivity needs across unlimited locations worldwide. Unified billing, centralized support, and consistent service delivery eliminate vendor management complexity."
  },
  {
    icon: Globe2,
    title: "Global Deployment Capabilities",
    description: "Connectivity solutions deployed across 200+ countries through relationships with 800+ carrier networks. From urban headquarters to remote field operations, we deliver connectivity everywhere your business operates."
  },
  {
    icon: Headphones,
    title: "24/7 US-Based Expert Support",
    description: "Direct access to network engineers and connectivity specialists—no outsourced call centers or chatbot-only support. Our NOC proactively monitors all circuits with specialized expertise in failover, IoT protocols, and enterprise connectivity."
  },
  {
    icon: Zap,
    title: "Technology Agnostic Solutions",
    description: "We recommend the right technology for each application—fiber, wireless, satellite, bonded solutions, or hybrid architectures. Our experts analyze requirements, coverage, and budget to design optimal connectivity strategies."
  },
  {
    icon: Rocket,
    title: "Rapid Deployment Timelines",
    description: "Deploy connectivity in days, not weeks or months. Wireless solutions activate in 24-48 hours. POTS replacements install in 7-10 days. Even complex multi-site deployments complete faster than traditional ISP timelines."
  },
  {
    icon: BarChart,
    title: "Enterprise-Grade Management",
    description: "Centralized platform managing connectivity across all locations with real-time monitoring, automated failover, usage analytics, and comprehensive reporting. API integration available for custom enterprise requirements."
  }
];

export const HomeWhySimNet = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-background to-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-primary">
            Why Choose SimNet for Business Connectivity
          </h2>
          <p className="text-xl text-muted-foreground max-w-4xl mx-auto">
            Enterprise-grade solutions with the flexibility of a specialized provider and the reliability of a carrier-grade network
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {valueProps.map((prop, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="glass-card p-8 rounded-xl hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center mb-6 shadow-lg">
                <prop.icon className="w-7 h-7 text-white" />
              </div>

              <h3 className="text-2xl font-bold mb-4">{prop.title}</h3>
              <p className="text-muted-foreground leading-relaxed">
                {prop.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
